import React from "react";
import { Box, Button } from "@mui/material";
import { useModal } from "../../../contexts/modal/hooks";

export const NameRunButtons = ({
  onTriggerRun,
  onDiscard,
  runName,
  setError,
}: {
  onTriggerRun?: (runName: string) => void;
  onDiscard: () => void;
  runName: string;
  setError: (error: string) => void;
}) => {
  const { closeModal } = useModal();

  const handleTriggerRun = () => {
    if (!runName.trim()) {
      setError("Run name is required");
      return;
    }

    setError("");
    if (onTriggerRun) {
      onTriggerRun(runName.trim());
    }

    closeModal();
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
      <Button
        variant="outlined"
        color="error"
        onClick={() => {
          onDiscard();
          closeModal();
        }}
      >
        Discard Changes
      </Button>

      <Button
        variant="contained"
        color="primary"
        onClick={handleTriggerRun}
        disabled={!runName.trim()}
      >
        Trigger Run
      </Button>
    </Box>
  );
};
